/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.4",
    versionName: "0.2.0-nightly.2026.2.4",
    versionChannel: "nightly",
    buildDate: "2026-02-04T00:09:59.726Z",
    commitHash: "31fe1c8d71f562ded7a8de09aff3ab56325b6be6",
};
